(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "query-string", "axios", "js-cookie", "./config", "./noperm"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("query-string"), require("axios"), require("js-cookie"), require("./config"), require("./noperm"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global.queryString, global.axios, global.jsCookie, global.config, global.noperm);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _asyncToGenerator2, _queryString, _axios, _jsCookie, _config, _noperm) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _queryString = _interopRequireDefault(_queryString);
  _axios = _interopRequireDefault(_axios);
  _jsCookie = _interopRequireDefault(_jsCookie);
  _config = _interopRequireDefault(_config);
  _noperm = _interopRequireDefault(_noperm);

  // 兼容旧版本代码
  var instance = _axios["default"].create({
    baseURL: _config["default"].API_URL,
    withCredentials: false
  });

  var instanceTest = _axios["default"].create({
    baseURL: _config["default"].TEST_API_URL,
    withCredentials: false
  });

  var _default = {
    // 跳转登陆
    login: function login(_ref) {
      var _ref$project = _ref.project,
          project = _ref$project === void 0 ? "" : _ref$project,
          _ref$url = _ref.url,
          url = _ref$url === void 0 ? window.location.href : _ref$url,
          _ref$qa = _ref.qa,
          qa = _ref$qa === void 0 ? false : _ref$qa,
          _ref$copyright = _ref.copyright,
          copyright = _ref$copyright === void 0 ? JSON.stringify({
        guardian: "",
        // 维护人
        team: {
          name: "",
          // 开发组
          link: "" // 组介绍连接

        },
        feedback: "" // 反馈连接

      }) : _ref$copyright;

      _jsCookie["default"].remove(_config["default"].TOKEN_SCHEMA, {
        path: '/',
        domain: window.location.hostname
      });

      if (!project) {
        _noperm["default"].login.apply(_noperm["default"], arguments);

        return;
      } // 存QA


      _jsCookie["default"].set(_config["default"].QA_SCHEMA, qa, {
        expires: _config["default"].TOKEN_EXPIRES,
        path: '/',
        domain: window.location.hostname
      }); // 存project


      _jsCookie["default"].set(_config["default"].PROJECT_SCHEMA, project, {
        expires: _config["default"].TOKEN_EXPIRES,
        path: '/',
        domain: window.location.hostname
      }); // 跳转登陆


      window.location.href = "".concat(_config["default"].LOGIN_URL, "/perm?project=").concat(project, "&redirect_url=").concat(encodeURIComponent(url), "&copyright=").concat(copyright, "&is_qa=").concat(qa ? '1' : '0');
    },
    // 获取token
    getToken: function getToken() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$isPerm = _ref2.isPerm,
          isPerm = _ref2$isPerm === void 0 ? false : _ref2$isPerm;

      if (!isPerm) {
        return _noperm["default"].getToken();
      } // cookie获取


      var hostname = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/gim.exec(window.location)[1];

      var token = _jsCookie["default"].get(_config["default"].TOKEN_SCHEMA, {
        path: '/',
        domain: window.location.hostname
      });

      if (!token) {
        // url获取
        token = _queryString["default"].parse(window.location.search.slice(1)).token || '';
      }

      return token;
    },
    // 获取用户信息
    getUserInfo: function getUserInfo() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$isPerm = _ref3.isPerm,
          isPerm = _ref3$isPerm === void 0 ? false : _ref3$isPerm;

      return (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var tokenInCookie, tokenInUrl, token, hostname, queryList, url, isQa, api, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isPerm) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", _noperm["default"].getUserInfo());

              case 2:
                // cookie获取
                tokenInCookie = _jsCookie["default"].get(_config["default"].TOKEN_SCHEMA, {
                  path: '/',
                  domain: window.location.hostname
                }); // url获取

                tokenInUrl = _queryString["default"].parse(window.location.search.slice(1)).token;
                token = tokenInUrl || tokenInCookie; // 未获取到token返回null

                if (token) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", null);

              case 7:
                if (Array.isArray(token)) {
                  token = token[token.length - 1];
                } // cookie没有token，从url获取并保存


                if (tokenInUrl && tokenInCookie !== tokenInUrl) {
                  hostname = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/gim.exec(window.location)[1];

                  _jsCookie["default"].set(_config["default"].TOKEN_SCHEMA, token, {
                    path: '/',
                    expires: _config["default"].TOKEN_EXPIRES,
                    domain: window.location.hostname
                  });
                }

                if (tokenInUrl) {
                  queryList = _queryString["default"].parse(window.location.search.slice(1));
                  delete queryList.token;
                  url = window.location.href.replace(window.location.search.slice(1), _queryString["default"].stringify(queryList));
                  window.location.replace(url);
                } // 获取用户信息


                isQa = _jsCookie["default"].get(_config["default"].QA_SCHEMA, {
                  path: '/',
                  domain: window.location.hostname
                });
                api = isQa && isQa === 'true' ? instanceTest : instance;
                _context.next = 14;
                return api.get('/member/getMember', {
                  params: {
                    project: _jsCookie["default"].get(_config["default"].PROJECT_SCHEMA, {
                      path: '/',
                      domain: window.location.hostname
                    }),
                    token: token
                  }
                });

              case 14:
                res = _context.sent;

                if (!(res.status === 200 && !res.data.code && res.data.data && res.data.data.member)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", res.data.data.member);

              case 19:
                return _context.abrupt("return", null);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 登出
    logout: function logout() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$isPerm = _ref4.isPerm,
          isPerm = _ref4$isPerm === void 0 ? false : _ref4$isPerm;

      return (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        var token, h;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                h = function _ref5() {
                  if (token) {
                    _jsCookie["default"].remove(_config["default"].PROJECT_SCHEMA, {
                      path: '/',
                      domain: window.location.hostname
                    });

                    _jsCookie["default"].remove(_config["default"].TOKEN_SCHEMA, {
                      path: '/',
                      domain: window.location.hostname
                    });

                    _jsCookie["default"].remove(_config["default"].QA_SCHEMA, {
                      path: '/',
                      domain: window.location.hostname
                    });

                    var queryList = _queryString["default"].parse(window.location.search.slice(1));

                    if (!!queryList.token) {
                      delete queryList.token;
                      var url = window.location.href.replace(window.location.search.slice(1), _queryString["default"].stringify(queryList));
                      window.location.replace(url);
                    } else {
                      window.location.reload();
                    }
                  }

                  return true;
                };

                if (isPerm) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", _noperm["default"].logout());

              case 3:
                token = exports["default"].getToken({
                  isPerm: isPerm
                });

                _axios["default"].get('https://login.qutoutiao.net/api/login/logout', {
                  withCredentials: true,
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                }).then(function (response) {
                  h();
                })["catch"](function (err) {
                  h();
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  };
  _exports["default"] = _default;
});


//////////////////
// WEBPACK FOOTER
// ./~/@qtt/ewx-login-sdk/lib/index.js
// module id = 78
// module chunks = 24